import { Action } from 'redux';
import { IModuleSwiperItem } from 'sofa-reborn-react';

// State
export interface SwiperState {
	moduleItems: Array<IModuleSwiperItem>;
	dragItemId: string | null;
	eventType: 'click' | 'drag' | null;
	previousDraggedItemId: string | null;
	selectedItemId: string | null;
	previousSelectedItemId: string | null;
	moduleItemsChanged: boolean;
}

// Actions
export const SET_ITEMS_IN_MODULE_SWIPER = 'SET_ITEMS_IN_MODULE_SWIPER';
export const SET_DRAG_ITEM_ID = 'SET_DRAG_ITEM_ID';
export const SET_SWIPER_EVENT_TYPE = 'SET_SWIPER_EVENT_TYPE';
export const SET_SELECTED_ITEM_ID = 'SET_SELECTED_ITEM_ID';
export const SET_MODULE_ITEMS_CHANGED = 'SET_MODULE_ITEMS_CHANGED';

interface SetItemsInModuleSwiper extends Action {
	type: typeof SET_ITEMS_IN_MODULE_SWIPER;
	value: Array<IModuleSwiperItem>;
}

interface SetDragItemId extends Action {
	type: typeof SET_DRAG_ITEM_ID;
	value: string | null;
	origin: 'swiper' | 'scene';
}
interface SetSwiperEventType extends Action {
	type: typeof SET_SWIPER_EVENT_TYPE;
	value: { type: 'click' | 'drag' | null; productId: string | null };
}

interface SetSelectedItemId extends Action {
	type: typeof SET_SELECTED_ITEM_ID;
	value: string | null;
}

interface SetModuleItemsChanged extends Action {
	type: typeof SET_MODULE_ITEMS_CHANGED;
	value: boolean;
}

export type SwiperStateActions =
	| SetItemsInModuleSwiper
	| SetDragItemId
	| SetSwiperEventType
	| SetModuleItemsChanged
	| SetSelectedItemId;
